import { Box, Pagination } from "@mui/material";
import useProducts from "../../../hooks/context/useProducts";
import ImageProduct from "../../../assets/images/Produtos.png";
import { useEffect, useState } from "react";
import { useBreakpoints } from "../../../hooks/useBreakpoins";
import {
  FadeInContainer,
  NoData,
} from "../../../components/AtomicDesign/Atoms";
import { ProductList } from "../../../components/AtomicDesign/Organisms";
import { LateralFilters } from "../../../components/AtomicDesign/Molecules";

export function Products() {
  const { productsDataMemo, records, setProductsFilters, productsfilters } =
    useProducts();
  const { isSmalldesktop, isMobile, semiSmalldesktop } = useBreakpoints();
  const [pageNow, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [
    productsfilters.inStock,
    productsfilters.isRare,
    productsfilters.name,
    productsfilters.originName,
    productsfilters.outOfStock,
    productsfilters.productTypeName,
    productsfilters.versionName,
  ]);

  const verifyIMGWidth = () => {
    if (isMobile) return { w: "90%", h: 200 };
    if (isSmalldesktop) return { w: "90%", h: 300 };
    if (semiSmalldesktop) return { w: "80%", h: 400 };
    return { w: "75%", h: 500 };
  };

  return (
    <Box width={"100%"}>
      <FadeInContainer>
        <Box
          display={"flex"}
          width={"100%"}
          gap={2}
          mt={2}
          p={isSmalldesktop ? 0 : 1}
          flexWrap={"wrap"}
          justifyContent={isSmalldesktop ? "center" : "flex-start"}
        >
          <Box display={"flex"} width={"100%"} justifyContent={"center"} mb={2}>
            <img
              src={ImageProduct}
              alt="center products"
              width={verifyIMGWidth().w}
              height={verifyIMGWidth().h}
              style={{
                borderRadius: 20,
              }}
            />
          </Box>
          {productsDataMemo?.data?.length > 0 && (
            <Box
              display={"flex"}
              justifyContent={"center"}
              width={"100%"}
              mt={2}
              sx={{ ml: isSmalldesktop ? 0 : 37 }}
            >
              <Pagination
                count={records}
                shape="rounded"
                color="secondary"
                page={pageNow}
                defaultPage={1}
                onChange={(_e, page) => {
                  if (pageNow !== page) {
                    setProductsFilters((old) => ({ ...old, offset: page - 1 }));
                    setPage(page);
                  }
                }}
              />
            </Box>
          )}
          <Box
            display={"flex"}
            flexDirection={isSmalldesktop ? "column" : "row"}
            width={"100%"}
          >
            <LateralFilters />
            {productsDataMemo?.data?.length === 0 ? (
              <Box width={"100%"}>
                <NoData text="Sem resultados" />
              </Box>
            ) : (
              <Box
                display={"flex"}
                alignItems={"center"}
                flexDirection={"column"}
                width={"100%"}
              >
                <ProductList list={productsDataMemo?.data} />

                {productsDataMemo?.data?.length > 0 && (
                  <Box
                    display={"flex"}
                    justifyContent={"center"}
                    width={"100%"}
                  >
                    <Pagination
                      count={records}
                      shape="rounded"
                      color="secondary"
                      page={pageNow}
                      defaultPage={1}
                      sx={{
                        mt: 3,
                      }}
                      onChange={(_e, page) => {
                        if (pageNow !== page) {
                          setProductsFilters((old) => ({
                            ...old,
                            offset: page - 1,
                          }));
                          setPage(page);
                        }
                      }}
                    />
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </Box>
      </FadeInContainer>
    </Box>
  );
}
